const logos = {
  day: require("@/assets/day.png"),
  karafarin: require("@/assets/logo_karafarin.png"),
  isatis: require("@/assets/logo_isatis.png"),
  sarmad: require("@/assets/logo_sarmad.png"),
  novin:require("@/assets/logo_novin.png"),
};

const names = {
  day: "بیمه دی",
  karafarin: "بیمه کارآفرین",
  isatis: "بیمه ایساتیس",
  sarmad: "بیمه سرمد",
  novin : "بیمه نوین"
};

export function getCompanyLogo(compId) {
  return logos[compId] || null;
}

export function getCompanyName(compId) {
  return names[compId] || "Insurance";
}
